import axios from 'axios'

class OperationalService {
  constructor() {
    this.baseUrl = '/api/v1/operationsdashboard'
  }

  saveOperation(data) {
    return axios.post(`${this.baseUrl}/save_operations/`, data)
  }
}

export const operationalService = new OperationalService()
